import { TextSpan } from 'app/typography';
import BasicBlock from '../components/BasicBlock';
import TypeIcon from '../TypeIcon';
import FieldsTable from '../FieldsTable';

function SubmissionLabel({ initiator }) {
  const { name, type } = initiator;
  const base = 'survey submitted';

  if (type === 'employee') {
    return (
      <>
        <TextSpan size="micro">{base} by </TextSpan>
        <TextSpan weight="bold" size="micro">
          {name}
        </TextSpan>
      </>
    );
  }

  return <TextSpan size="micro">{base}</TextSpan>;
}

const SurveySubmittedEventBlock = ({ event, ...others }) => {
  return (
    <BasicBlock
      comments={event.comments}
      icon={
        <TypeIcon
          color="var(--color-viz-cat-8-primary)"
          icon="poll"
          size="16px"
        />
      }
      isEmpty
      timestamp={event.created}
      title={
        <>
          <TextSpan weight="bold" size="micro">
            {event.data.surveyName}
            {event.data.formName}
          </TextSpan>{' '}
          <SubmissionLabel initiator={event.initiator} />
        </>
      }
      event={event}
      {...others}
    >
      <FieldsTable fields={event.data.fields} />
    </BasicBlock>
  );
};

export default SurveySubmittedEventBlock;
